<template>
    <span class="pa-badge" :class="`pa-badge--${tone}`">
        <span class="pa-badge__dot"></span>
        <slot>{{ label }}</slot>
    </span>
</template>

<script>
// Status: ponto colorido + texto em fundo suave da mesma cor. `status` aceita os
// status da campanha, das versoes e dos termos; `tone` forca uma cor.
const STATUS = {
    draft: ["Rascunho", "neutral"],
    open: ["Aberta", "success"],
    closed: ["Encerrada", "neutral"],
    pending_approval: ["Aguardando aprovação", "warning"],
    approved: ["Aprovado", "success"],
    rejected: ["Rejeitado", "danger"],
    published: ["Publicado", "success"],
    superseded: ["Substituído", "neutral"],
    awaiting_signature: ["Aguardando assinatura", "neutral"],
    submitted: ["Em análise", "warning"],
    in_review: ["Em análise", "warning"],
    revoked: ["Revogado", "danger"],
    cancelled: ["Cancelado", "neutral"],
    sent: ["Enviado", "success"],
    pending: ["Na fila", "info"],
    retry: ["Nova tentativa", "warning"],
    failed: ["Falhou", "danger"],
};

export default {
    name: "PaBadge",
    props: {
        status: { type: String, default: null },
        text: { type: String, default: null },
        variant: { type: String, default: null },
    },
    computed: {
        label() {
            return this.text || (STATUS[this.status] ? STATUS[this.status][0] : this.status);
        },
        tone() {
            return this.variant || (STATUS[this.status] ? STATUS[this.status][1] : "neutral");
        },
    },
};
</script>

<style>
.pa-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 24px;
    padding: 0 9px;
    border-radius: 6px;
    background: #f1f5f9;
    color: #475569;
    font-size: 12.5px;
    font-weight: 500;
    white-space: nowrap;
}
.pa-badge__dot { width: 6px; height: 6px; border-radius: 50%; background: #94a3b8; }
.pa-badge--success { background: #ecf8f0; color: #15803d; }
.pa-badge--success .pa-badge__dot { background: #16a34a; }
.pa-badge--warning { background: #fdf3e7; color: #b45309; }
.pa-badge--warning .pa-badge__dot { background: #d97706; }
.pa-badge--danger { background: #fdeeee; color: #b91c1c; }
.pa-badge--danger .pa-badge__dot { background: #dc2626; }
.pa-badge--info { background: #eef4ff; color: #1d4ed8; }
.pa-badge--info .pa-badge__dot { background: #2563eb; }
</style>
